<template>
	<div class="bullehead FlexBetween" :style="customStyle">
		<div class="head_left FlexRow">
			<div class="head_title">
				{{title || ''}}
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'bullehead',
		props: {
			title: {
				type: String,
				default: '',
			},
			customStyle: {
				type: String,
				default: '',
			},
		},
		data(){
			return {
				
			}
		},
		
	}
</script>

<style lang="scss" scoped>
	.bullehead{
		width: 100%;
		min-height: 55px;
		background-color: #fff;
		border-bottom: solid 1px rgba(243, 243, 243, 1);
		padding: 0 25px;
		.head_title{
			font-size: 16px;
			font-weight: 550;
			color: rgba(51, 51, 51, 1);
			text-align: left;
			
		}
	}
	
</style>